import { Form } from 'antd';
import React, { useState } from 'react';

const MyTable = (props) => {
  const [data, setData] = useState(
    props?.defaultData.length !== 0
      ? props.defaultData
      : [{ column1: '-', column2: '-' }]
  );

  const handleChange = (e, rowIndex, columnName) => {
    const newData = [...data];
    newData[rowIndex][columnName] = e.target.value;
    setData(newData);
  };

  const addRow = () => {
    setData([...data, { column1: 'name', column2: 'link' }]);
  };

  const removeRow = (idx) => {
    if (data.length <= 1) return;
    const newData = data.filter((_, i) => i !== idx);
    setData(newData);
    props.setTableData(newData);
  };

  return (
    <div className="data-table-section">
      <div className="data-table-header">
        <h4>{props.title}</h4>
        <button type="button" className="btn btn-secondary btn-sm" onClick={addRow}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M12 5v14M5 12h14" />
          </svg>
          Add row
        </button>
      </div>
      <div className="data-table-wrap">
        <table onChange={() => { props.setTableData(data); }}>
          <thead>
            <tr>
              <th>Display Name</th>
              <th>Link</th>
              <th style={{ width: 80 }}></th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>
                  <input
                    type="text"
                    className="data-table-input"
                    value={row.column1}
                    onChange={(e) => handleChange(e, rowIndex, 'column1')}
                    placeholder="Name"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="data-table-input"
                    value={row.column2}
                    onChange={(e) => handleChange(e, rowIndex, 'column2')}
                    placeholder="https://..."
                  />
                </td>
                <td>
                  <div className="data-table-actions">
                    <a
                      href={row.column2}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-ghost btn-sm"
                      title="Open link"
                    >
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                        <polyline points="15 3 21 3 21 9" />
                        <line x1="10" y1="14" x2="21" y2="3" />
                      </svg>
                    </a>
                    <button
                      type="button"
                      className="btn btn-ghost btn-sm"
                      onClick={() => removeRow(rowIndex)}
                      title="Remove row"
                      disabled={data.length <= 1}
                      style={{ color: data.length <= 1 ? 'var(--text-tertiary)' : 'var(--error)' }}
                    >
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MyTable;
